import React, { Fragment, useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
// import { Link } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from "moment";
import Button from "../../components/button";
import { Label } from "reactstrap";

const InstantHushPatientContactForm = props => {
  // const doctorContactByTimeOptions = ["Select Date and Time" /*, "Free Type"*/];
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedTime, setSelectedTime] = useState("");
  const [timeSelectionOptions, setTimeSelectionOptions] = useState([]);

  const getIncrementedHoursList = fromDate => {
    let currentHour = fromDate;
    const copyOfFromDate = fromDate;
    let intHour = +copyOfFromDate.add(1, "hour").format("HH");
    let newHoursList = [];
    for (let i = intHour; i < 24; i++) {
      if (i >= 9 && i <= 23) {
        newHoursList.push(currentHour.format("hh:00 a"));
      }
      currentHour = currentHour.add(1, "hour");
    }
    setTimeSelectionOptions(newHoursList);
    console.log("Incremented Hours: ", timeSelectionOptions);
  };

  const formik = useFormik({
    initialValues: {
      adminSelectionOption: "",
      selectedDoctorContactByTime: "",
      other: "",
      selectedDate: new Date().toISOString(),
      selectedTime: ""
    },
    validationSchema: Yup.object({
      // adminSelectionOption: Yup.string().required("Please select"),
      // other: Yup.string()
      //     .when("adminSelectionOption", {
      //         is: "Free Type",
      //         then: Yup.string().required("Please enter free type text")
      //     }),
      // selectedDate: Yup.string()
      //     .when("adminSelectionOption", {
      //         is: "Select Date and Time",
      //         then: Yup.string().required("Please select the date")
      //     }),
      selectedTime: Yup.string().required("Please select the time")
      // .when("adminSelectionOption", {
      //     is: "Select Date and Time",
      //     then: Yup.string().required("Please select the time")
      // }),
    }),
    onSubmit: values => {
      console.log("Formik values: ", values);
      let dataToSend = {
        doctorContactByTime: values.selectedDoctorContactByTime,
        patientPreferredTime: ""
      };
      // if (values.adminSelectionOption !== "Select Date and Time") {
      // dataToSend['doctorContactByTime'] = formik.values.other;
      // dataToSend['patientPreferredTime'] = formik.values.other;
      // }
      console.log("Data to send: ", dataToSend);
      props.onFormSubmit(dataToSend);
    }
  });

  const updateCustomText = () => {
    console.log("update >" , selectedDate + " " + selectedTime, "DD-MM-YYYY hh:mm a")
    const  formattedDate = moment(selectedDate).format("DD-MM-YYYY");
    const date = moment(formattedDate + " " + selectedTime, "DD-MM-YYYY hh:mm a").toISOString();
    console.log({ date });
    formik.values.selectedDoctorContactByTime = date;
  };

  const handleDateChanges = date => {
    console.log("Date changes: ", date);
    setSelectedDate(date);
    setSelectedTime("");
    formik.values.selectedDate = date.toISOString();

    const selectedDate = moment(date).startOf("day");
    console.log(
      "Selected date: ",
      selectedDate,
      selectedDate.format("hh:mm a")
    );
    const isSelectedDateIsAfter = selectedDate.isAfter(moment());
    const hoursToSetFrom = isSelectedDateIsAfter ? selectedDate : moment();
    getIncrementedHoursList(hoursToSetFrom);
  };

  const handleTimeSelection = event => {
    console.log("Time has changed: ", event);
    setSelectedTime(event.target.value);
    formik.values.selectedTime = event.target.value;
  };

  useEffect(() => {
    // load incremental hours from current time
    getIncrementedHoursList(moment());
  }, []);

  useEffect(() => {
    console.log("Formik values: ", formik.values);
    updateCustomText();
    setTimeout(() => {
      console.log("UpdatedFormik values: ", formik.values);
    }, 2000);
  }, [selectedDate, selectedTime]);

  return (
    <form
      className="d-flex flex-column align-items-center"
      onSubmit={formik.handleSubmit}
    >
      {/* <TextField
                select
                id="adminSelectionOption"
                name="adminSelectionOption"
                onChange={(e) => {
                    formik.values.adminSelectionOption = e.target.value;
                    formik.setFieldValue("adminSelectionOption", e.target.value);
                    formik.handleChange('adminSelectionOption');
                    formik.values.selectedDate = new Date().toISOString();
                    formik.values.selectedTime = '';
                    formik.values.other = '';
                }}
                onBlur={formik.handleBlur}
                value={formik.values.adminSelectionOption}
                SelectProps={{
                    native: true
                }}
                className="mt-1 pt-1 w-100"
                error={formik.touched.adminSelectionOption && formik.errors.adminSelectionOption ? true : false}
                helperText={
                    formik.touched.adminSelectionOption && formik.errors.adminSelectionOption
                        ? formik.errors.adminSelectionOption
                        : ""
                }
            >
                <option value="" disabled>Select Option</option>
                {
                    doctorContactByTimeOptions.map((value, index) => {
                        return (<option value={value}>{value}</option>)
                    })
                }
            </TextField> */}
      <br />
      {/* {
                formik.values.adminSelectionOption === "Free Type" && (
                    <Fragment>
                        <ICInput
                            id="other"
                            name="other"
                            type="text"
                            label="Enter free type text here..."
                            // placeholder="Enter free type text here..."
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.other}
                            error={formik.touched.other && formik.errors.other ? true : false}
                            helperText={
                                formik.touched.other && formik.errors.other
                                    ? formik.errors.other
                                    : ""
                            }
                        />
                    </Fragment>
                )
            } */}

      {
        // formik.values.adminSelectionOption === "Select Date and Time" true && (

        <Fragment className="d-flex">
          <Label className="d-flex w-100 pb-2">Select Date and Time</Label>
          <div className="d-flex w-100">
            <KeyboardDatePicker
              name="selectedDate"
              style={{ width: "135px" }}
              autoOk
              variant="inline"
              mask="__-__-____"
              format="DD-MM-YYYY"
              label="Select Date"
              className="mr-2"
              value={selectedDate}
              minDate={moment()}
              onChange={date => handleDateChanges(date)}
            />
            <TextField
              select
              SelectProps={{
                native: true
              }}
              onChange={handleTimeSelection}
              value={selectedTime}
              className="ml-2 pt-3"
            >
              <option value="" disabled>
                Select Time
              </option>
              {timeSelectionOptions.map((value, index) => {
                return (
                  <option key={index} value={value}>
                    {value}
                  </option>
                );
              })}
            </TextField>
          </div>
        </Fragment>
        // )
      }
      <br />
      <div className="d-flex mt-3 justify-content-center align-items-center">
        <Button title="Confirm" type="submit" />
        <Button
          title="Close"
          type="button"
          className="ml-3"
          clickEvent={props.onCancle}
        />
      </div>
    </form>
  );
};

export default InstantHushPatientContactForm;

InstantHushPatientContactForm.defaultProps = {
  serverErrorMsg: ""
};

InstantHushPatientContactForm.propTypes = {
  onFormSubmit: PropTypes.func,
  onCancle: PropTypes.func,
  serverErrorMsg: PropTypes.string
};
